import createFetchActions from './createFetchActions';

const deleteReportActions = createFetchActions('DELETE_REPORT');

const fetchReportListActions = createFetchActions('REPORTS_LIST');

export { deleteReportActions, fetchReportListActions };
